import { applyMiddleware, createStore } from "redux";

import createSagaMiddleware from "redux-saga";
import { persistStore } from "redux-persist";
import rootReducer from "./rootReducer";
import rootSaga from "./webSagas";
import { routerMiddleware } from "connected-react-router";
import history from "@utils/history";
import { composeWithDevTools } from "redux-devtools-extension";
import { injectStore } from "@common/utils/storeInjection";

const enhancer = (middleware) => {
  if (process.env.NODE_ENV !== "production")
    return composeWithDevTools(middleware);
  return middleware;
};

const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routerMiddleware(history)];
const enhancers = applyMiddleware(...middlewares);

const store = createStore(rootReducer, enhancer(enhancers));
sagaMiddleware.run(rootSaga);

export type IRootReducer = ReturnType<typeof rootReducer>;

injectStore(store);
export default store;
export const persistor = persistStore(store);
const storeState = store.getState();
export type RootState = typeof storeState;
export type AppDispatch = typeof store.dispatch;
